<template>
    <!-- 这一坨是课程目录 -->
    <div v-show="this.$route.query.id !== undefined" class="container">
      <div class="row">
        <div class="col-12" style="background-color: rgb(226, 229, 229);">
            <div style="font-size: 20px; color: red; text-align: center;" v-if="error_message !== ''">{{ error_message }}</div>
            <div class="row" style="padding-top: 10px;">
                <el-popover
                    placement="bottom"
                    title="标题"
                    width="700"
                    trigger="click"
                    content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
                    >
                    <el-input
                        type="text"
                        placeholder="请输入标题"
                        v-model="title"
                        maxlength="100"
                        show-word-limit
                        >
                    </el-input>
                    <el-input
                        style="margin-top: 10px;"
                        type="textarea"
                        placeholder="请输入内容"
                        v-model="content"
                        maxlength="1000"
                        show-word-limit
                        >
                    </el-input>
                    <span>编号:</span>
                    <el-input-number 
                        placeholder="请输入编号"
                        style="margin-top: 10px; margin-left: 10px;" 
                        v-model="number" 
                        :min="1" 
                        :max="999" 
                        label="123"
                        >
                    </el-input-number>
                    <div>
                        <el-button type="text" style="margin-left: 290px;" @click="AddCatalog">上传到后端</el-button>
                    </div>
                    <div style="text-align: center; font-size: 30px;" slot="reference"><i class="el-icon-plus hh" style="border: 3px solid black"></i></div>
                </el-popover>
                <div class="accordion" id="accordionPanelsStayOpenExample">
                    <div class="accordion-item" v-for="(item, index) in catalog" :key="index">
                        <h2 class="accordion-header">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" 
                            :data-bs-target="'#c' + item.id" aria-expanded="false" 
                            :aria-controls="'c' + item.id" style="font-size: 16px;">
                                {{ item.title }}
                            </button>
                        </h2>
                        <div :id="'c' + item.id" class="accordion-collapse collapse">
                            <div class="accordion-body" style="font-size: 14px;">
                                <div class="row">
                                    <div class="col-10" style="font-size: 14px;">
                                        {{ item.content }}
                                        {{ item.number }}
                                    </div>
                                    <div class="col-2">
                                        <el-popover
                                            placement="bottom"
                                            title="标题"
                                            width="700"
                                            trigger="click"
                                            content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
                                            >
                                            <el-input
                                                type="text"
                                                placeholder="请输入标题"
                                                v-model="title"
                                                maxlength="100"
                                                show-word-limit
                                                >
                                            </el-input>
                                            <el-input
                                                style="margin-top: 10px;"
                                                type="textarea"
                                                placeholder="请输入内容"
                                                v-model="content"
                                                maxlength="1000"
                                                show-word-limit
                                                >
                                            </el-input>
                                            <span>编号:</span>
                                            <el-input-number 
                                                placeholder="请输入编号"
                                                style="margin-top: 10px; margin-left: 10px;" 
                                                v-model="number" 
                                                :min="1" 
                                                :max="999" 
                                                label="123"
                                                >
                                            </el-input-number>
                                            <div>
                                                <el-button type="text" style="margin-left: 290px;" @click="UpdateCatalog(item.id)">上传到后端</el-button>
                                            </div>
                                            <el-button slot="reference" type="text" style="margin-left: 10PX;" @click="openUpdate(item)">修改</el-button>
                                        </el-popover>
                                        <el-button type="text" style="margin-left: 10px;" @click="DeleteCatalog(item.id)">删除</el-button>
                                    </div>
                                    <div class="col-12"><hr></div>
                                    <div class="col-11" style="font-size: 14px; margin: 5px auto;">
                                        <CourseVideoTemplate v-if="isOpen" :cId="item.id"></CourseVideoTemplate>
                                    </div>
                                    <div class="col-12"><hr></div>
                                    <div class="col-11" style="font-size: 14px; margin: 5px auto;">
                                        <CatalogProlbemTemplate v-if="isOpen" :cId="item.id"></CatalogProlbemTemplate>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
</template>

<script>
    import $ from "jquery"
    import CatalogProlbemTemplate from './CatalogProblemTemplate.vue'
    import CourseVideoTemplate from './CourseVideoTemplate.vue'
    export default {
        name:'CourseCatalog',
        components: {
            CatalogProlbemTemplate,
            CourseVideoTemplate
        },
        data() {
            return {
                isOpen:false,
                visible: false, // 打开弹窗用的
                activeNames: [], // 这个是目录

                catalog:[],

                courseId: '',
                title: '',
                content: '',
                number: '',
                
                error_message:'',
            }
        },
        mounted() {
            console.log(this.$route.query)
            // console.log("我是目录，我被创造了")
            if (this.$route.query.id !== undefined)
            this.GetCatalog()
        },
        methods: {
            handleChange(val) {
                console.log(val);
            },
            openUpdate(item) {
                this.title = item.title
                this.content = item.content
                this.number = item.number
                // this.UpdateCatalog(item.id)
            },
            UpdateCatalog(id) {
                // console.log("我进来了")
                const vue = this
                const store = this.$store
                const route = this.$route
                $.ajax({
                    url:'https://app6132.acapp.acwing.com.cn/api/catalog/update/',
                    type:'post',
                    headers: {
                        Authorization: "Bearer " + store.state.me.token,
                    },
                    data: {
                        id: id,
                        courseId: route.query.id,
                        title: vue.title,
                        content: vue.content,
                        number: vue.number
                    },
                    success(resp) {
                        if (resp.error_message === "success") {
                            // console.log("修改目录成功了")
                        } else {
                            console.log("修改目录失败了, resp == 》", resp.error_message)
                            vue.error_message = resp.error_message
                        }
                    },
                    error(resp) {
                        console.log("修改目录彻底失败了, resp == >", resp)
                    }
                })
            },
            DeleteCatalog(id) {
                const vue = this
                const store = this.$store

                $.ajax({
                    url:'https://app6132.acapp.acwing.com.cn/api/catalog/delete/',
                    type:'post',
                    headers: {
                        Authorization: "Bearer " + store.state.me.token,
                    },
                    data: {
                        id: id,
                    },
                    success(resp) {
                        if (resp.error_message === "success") {
                            console.log("删除目录成功了")
                        } else {
                            vue.error_message = resp.error_message
                        }
                    },
                    error(resp) {
                        console.log("删除目录彻底失败了, resp == >", resp)
                    }
                })
            },
            GetCatalog() { // 获取所有目录 
                const vue = this
                const store = this.$store
                const route = this.$route

                $.ajax({
                    url:'https://app6132.acapp.acwing.com.cn/api/catalog/read/list/',
                    type:'post',
                    data: {
                        courseId: route.query.id,
                    },
                    success(resp) {
                        if (resp.error_message === "success") {
                            // console.log("获取目录成功了")
                            vue.catalog = JSON.parse(resp.List)
                            vue.isOpen = true
                            console.log(vue.catalog)
                        } else {
                            vue.error_message = resp.error_message
                            console.log("我获取了error_message")
                        }
                    },
                    error(resp) {
                        console.log("获取目录彻底失败了, resp == >", resp)
                    }
                })
            },
            AddCatalog() { // 增加目录
                const vue = this
                const store = this.$store
                const route = this.$route

                $.ajax({
                    url:'https://app6132.acapp.acwing.com.cn/api/catalog/create/',
                    type:'post',
                    headers: {
                        Authorization: "Bearer " + store.state.me.token,
                    },
                    data: {
                        courseId: route.query.id,
                        title: vue.title,
                        content: vue.content,
                        number: vue.number
                    },
                    success(resp) {
                        if (resp.error_message === "success") {
                            // console.log("添加目录成功了")
                            vue.GetCatalog()
                        } else {
                            vue.error_message = resp.error_message
                            console.log("我获取了error_message")
                        }
                    },
                    error(resp) {
                        console.log("添加目录彻底失败了, resp == >", resp)
                    }
                })
            },
        }
    }
</script>

<style scoped>
.hh:hover {
    cursor: pointer;
    color: green;
}
</style>